// der service-worke ist als pures js in src/bin/service-worker*.js
// der Service-Worker wirkt nur unterhalb seiner eigenen URL und muss daher direkt unter / abgelegt sein
// (oder man ändert aufwendig seinen Scope mit Hilfe von HTTP-Headern)

export default function registerPWA() {
	// Register the service worker
	if ('serviceWorker' in navigator) {
		const suffix = window.location.pathname.split('/')[2];

		// Wait for the 'load' event to not block other work
		window.addEventListener('load', async () => {
			// Try to register the service worker.
			try {
				const reg = await navigator.serviceWorker.register(`/service-worker-${suffix}.js`);
				console.log('registerPWA: Service worker registered!', reg);
			} catch (err) {
				console.log('registerPWA: Service worker registration failed: ', err);
			}
		});
	}
}
